import {
  isValidPostalCode,
  PostalCodeTextField2,
} from '@cxc/react-fds-components';
import { CountryCode } from 'libphonenumber-js';
import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { AemTextField } from '../../constants/types/AemTypes';
import {
  generateRules,
  RequiredErrorMessage,
  Validator,
} from './generateRules';

interface ControlledPostalCodeTextField2Props<T extends FieldValues> {
  control: Control<T, unknown>;
  field: AemTextField;
  validator?: Validator;
  country?: CountryCode;
  disabled?: boolean;
}

export const ControlledPostalCodeTextField2 = <T extends FieldValues>({
  control,
  field,
  country = 'US',
  ...textFieldProps
}: ControlledPostalCodeTextField2Props<T>) => {
  const { id, label, requiredErrorMessage, validationErrorMessage } = field;
  const simplifiedField = { requiredErrorMessage } as AemTextField;

  const rulesTry = generateRules(
    simplifiedField,
    validationErrorMessage
      ? (value: string): boolean | string =>
          isValidPostalCode(value, country) || validationErrorMessage
      : undefined
  );

  const required = (rulesTry.required as RequiredErrorMessage)?.value;
  return (
    <Controller
      name={id}
      control={control as Control}
      rules={rulesTry}
      defaultValue={''}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { error },
      }) => (
        <PostalCodeTextField2
          country={country}
          id={id}
          name={label}
          value={value as string | undefined}
          onChange={onChange}
          onBlur={onBlur}
          label={required ? `${label} *` : label}
          message={error?.message}
          error={error}
          required={!!required}
          {...textFieldProps}
        />
      )}
    />
  );
};
